'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fadeOut = exports.fadeIn = exports.formatMoney = exports.getProductData = exports.getProductMetafields = exports.fetchJSON = exports.getDefaultRequestConfig = exports.resizeImage = exports.range = exports.createElement = exports.doesStringContainAny = exports.getElements = exports.getElement = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.buildProperties = buildProperties;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the first element that is a descendant of node that
 * matches selectors.
 *
 * @param selector {String} A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} You can pass a context to scope the element selection
 * @param context {HTMLElement|Document} The scope we will try and find the element in
 *
 * @returns {HTMLElement} The found element or null
 */
var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};

/**
 * Returns a list of elements that are a descendant of node that
 * matches selectors.
 *
 * @param selector {String} A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} You can pass a context to scope the element selection
 * @param context {HTMLElement|Document} The scope we will try and find the element in
 * @param asArray {Boolean} Return the elements as an Array instead of an NodeList?
 *
 * @returns {Array|NodeList} The found elements or null
 */
var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? (0, _from2.default)(items) : items;
};

/**
 * Checks if the passed string contains any items in an array
 *
 * @param str {String} The string we will be searching
 * @param items {Array} A list of the items we will be checking for presence in the str
 *
 * @returns {Boolean}
 */
var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

/**
 * Creates an HTMLElement
 *
 * @param tag {String} What type of element we want this to be
 * @param options {Object} A key / value pair of properties and values we want to set on the newly
 *   created element
 *
 * @returns {HTMLElement}
 */
var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);

  (0, _entries2.default)(options).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    el.setAttribute(key, value);
  });

  return el;
};

/**
 * Creates an array starting from zero with the length of the passed amount
 *
 * @param amount {Number} How long do we want this array to be?
 *
 * @returns {Array}
 */
var range = exports.range = function range(amount) {
  return [].concat((0, _toConsumableArray3.default)(Array(amount).keys()));
};

/**
 * A Javascript equivalent of Shopify's | img_url filter
 *
 * @param {Object} The properties we will use to create the URL
 * @param src {String} The Shopify CDN URL of the image
 * @param size {String} What size we want the image to be
 * @param crop {null|String} By default the images aren't cropped but we can choose to crop them
 * @param scale {null|Number} Images are 1x by default, you can choose to pass a different scale
 *
 * @returns {String}
 */
var resizeImage = exports.resizeImage = function resizeImage() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      src = _ref5.src,
      size = _ref5.size,
      _ref5$crop = _ref5.crop,
      crop = _ref5$crop === undefined ? null : _ref5$crop,
      _ref5$scale = _ref5.scale,
      scale = _ref5$scale === undefined ? null : _ref5$scale;

  if (size == null) {
    return src;
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '');
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

  if (match != null) {
    var prefix = src.split(match[0]);
    var suffix = match[0];
    var scaleString = scale ? '@' + scale + 'x' : '';
    var cropString = crop ? '_crop_' + crop : '';

    return (prefix[0] + '_' + size + cropString + scaleString + suffix).replace(/http(s)?:/, '');
  } else {
    return null;
  }
};

var getDefaultRequestConfig = exports.getDefaultRequestConfig = function getDefaultRequestConfig() {
  return JSON.parse((0, _stringify2.default)({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
};

var fetchJSON = exports.fetchJSON = function fetchJSON(url, config) {
  return fetch(url, (0, _assign2.default)({}, getDefaultRequestConfig(), config)).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

var getProductMetafields = exports.getProductMetafields = function getProductMetafields(productHandle) {
  try {
    return fetchJSON('/products/' + productHandle + '?view=json', {
      method: 'GET'
    });
  } catch (error) {
    console.error('Couldn\'t get metafields for ' + productHandle, error);
  }
};

var getProductData = exports.getProductData = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(handle) {
    var _ref7, _ref8, data, metafields;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _promise2.default.all([fetchJSON('/products/' + handle + '.js'), getProductMetafields(handle)]);

          case 3:
            _ref7 = _context.sent;
            _ref8 = (0, _slicedToArray3.default)(_ref7, 2);
            data = _ref8[0];
            metafields = _ref8[1];
            return _context.abrupt('return', (0, _assign2.default)({}, data, {
              metafields: metafields
            }));

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 10]]);
  }));

  return function getProductData(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * This builds up the line item properties for use in Javascript
 *
 * @param formData {FormData} The form we will be traversing to find the properties
 *
 * @returns {Object}
 */
function buildProperties(formData) {
  var propertyKeyValues = [].concat((0, _toConsumableArray3.default)(formData.entries())).filter(function (_ref9) {
    var _ref10 = (0, _slicedToArray3.default)(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    return key.includes('properties[') && value !== '';
  });

  function propertyReducer(properties, _ref11) {
    var _ref12 = (0, _slicedToArray3.default)(_ref11, 2),
        key = _ref12[0],
        value = _ref12[1];

    var strippedKey = key.replace('properties[', '').slice(0, -1);

    return (0, _assign2.default)({}, properties, (0, _defineProperty3.default)({}, strippedKey, value));
  }

  return propertyKeyValues.reduce(propertyReducer, {});
}

var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme.moneyFormat;

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(/\{\{\s*(\w+)\s*\}\}/g, value);
};

/**
 * This will fade in an element passed to it
 *
 * @param {HTMLElement} el - Any HTML element
 *
 */
var fadeIn = exports.fadeIn = function fadeIn(el) {
  return new _promise2.default(function (resolve) {
    el.style.opacity = 0;
    var last = +new Date();
    var tick = function tick() {
      el.style.opacity = +el.style.opacity + (new Date() - last) / 400;
      last = +new Date();
      el.style.display = 'block';
      if (+el.style.opacity < 1) {
        ;window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 160);
        resolve();
      }
    };
    tick();
  });
};

/**
 * This will fade out an element passed to it
 *
 * @param {HTMLElement} el - Any HTML element
 *
 */
var fadeOut = exports.fadeOut = function fadeOut(el) {
  return new _promise2.default(function (resolve) {
    el.style.opacity = 1;(function fade() {
      if ((el.style.opacity -= 0.03) < 0) {
        el.style.display = 'none';
        resolve();
      } else {
        requestAnimationFrame(fade);
      }
    })();
  });
};